<template>
    <FilterFlyout :class="[hidden && 'hidden']">
        <div class="resubmit-form-modal-wrapper">
            <ResubmitForm
                :minLoanAmount="minLoanAmount"
                :maxLoanAmount="maxLoanAmount"
                :loanTerms="loanTerms"
                :loanValues="loanValues"
            />
        </div>
    </FilterFlyout>
</template>

<script>
import { useStore } from 'vuex'
import { loanTerms } from '@js/utilities/loanDetails.js'
import { maxLoanAmount, minLoanAmount } from '@js/utilities/loanDetails.js'

export default {
    props: {
        loanValues: Object,
        hidden: {
            default: true,
        },
    },
    setup() {
        const store = useStore()

        return {
            store,
        }
    },

    data() {
        return {
            showResubmit: false,
        }
    },
    computed: {
        maxLoanAmount,
        minLoanAmount,
        loanTerms,
    },
}
</script>

<style lang="scss">
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.resubmit-wrapper {
    background-color: var(--resubmit-background);
    font-family: var(--heading-font);
    width: 100%;
    display: flex;
    padding-top: 0px;
    padding-bottom: 0px;
    height: 0px;
    overflow: hidden;
    transition: all 0.5s ease;

    @media screen and (min-width: $bp-large) {
        &.reveal-resubmit {
            height: 73px;
            padding-top: 10px;
            padding-bottom: 10px;
        }

        &.has-errors {
            height: 91px;
        }
    }
}

.hidden {
    display: none;
    opacity: 0;
    visibility: hidden;
}
</style>
